import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxToolbarComponent } from './toolbar.component';

@NgModule({
	imports: [
		CommonModule
	],
	declarations: [
		NgxToolbarComponent
	],
	exports: [
		NgxToolbarComponent
	]
})
export class NgxToolbarModule {}
